module.exports = __webpack_public_path__ + "img/20.1529b41c.png";